import type { IOrganizationIntegrationCampaignMonitor } from './OrganizationIntegrationCampaignMonitor.interface';

export default class OrganizationIntegrationCampaignMonitor
  implements IOrganizationIntegrationCampaignMonitor {
  clientId: string;
  clientEmail: string;
  token: string;
  integrator: string;
  autoSyncListId: string;
  autoSyncList: string;
  autoSync: boolean;
  enabled: boolean;

  hasAuthentication() {
    return this.clientId && this.token;
  }

  hasAuthenticationEmbed() {
    return this.hasAuthentication() && this.clientEmail && this.integrator;
  }

  isEnabledAutoSync() {
    return this.enabled() && this.autoSync && this.autoSyncList && this.autoSyncListId;
  }

  isEnabled() {
    return this.enabled && this.hasAuthentication();
  }

  static build = (data: IOrganizationIntegrationCampaignMonitor) =>
    new OrganizationIntegrationCampaignMonitor(data);
  static blank = () => new OrganizationIntegrationCampaignMonitor();

  /**
   * Constructor
   * @param {IOrganizationIntegrationCampaignMonitor} data
   */
  constructor(data?: IOrganizationIntegrationCampaignMonitor) {
    this.clientId = data?.clientId || undefined;
    this.clientEmail = data?.clientEmail || undefined;
    this.token = data?.token || undefined;
    this.integrator = data?.integrator || undefined;
    this.autoSyncListId = data?.autoSyncListId || undefined;
    this.autoSyncList = data?.autoSyncList || undefined;
    this.autoSync = data?.autoSync === true;
    this.enabled = data?.enabled === true;
  }
}
